module.exports = __webpack_public_path__ + "img/lionpayment.108cdfac.svg";